import { attr, belongsTo } from '@warp-drive/legacy/model';
import DigitalAsset from './digital-asset.ts';
import type FileHistory from './file-history.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class RawFileDigitalAssetModel extends DigitalAsset {
  /*************************
   **  Attributes         **
   *************************/
  @attr declare description: string;
  @attr declare contentType: 'application/vnd.api+json';
  @attr declare classification: string;
  @attr declare externalUrl: string;

  /*************************
   **  Relationships      **
   *************************/
  @belongsTo('file-history', { async: false, inverse: 'rawFileDigitalAsset' })
  declare fileHistory: FileHistory;

  [Type] = 'raw-file-digital-asset' as const;
}
